import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getCurrentAccount } from '@app/core/_shared/services/storage/storage.service';

declare let environment: any;

@Injectable({ providedIn: 'root' })
export class TemplatesService {
  private url: string = environment.url;
  acc: string;

  constructor(private http: HttpClient) {}

  /**
   * Get all Templates
   */
  loadAll(): Observable<any> {
    this.acc = getCurrentAccount();
    return this.http.get<any>(`${this.url}/models?account=${this.acc}&skip=0&limit=10&sort=name`).pipe(map(res => res.result));
  }

  /**
   * Get paginated templates
   */
  loadPaginated(): Observable<any> {
    this.acc = getCurrentAccount();
    return this.http.get<any>(`${this.url}/v2/models?account=${this.acc}`).pipe(map(res => res.result));
  }

  /**
   * Load more templates
   */
  loadMore(skip: number, limit: number): Observable<any> {
    return this.http.get<any>(`${this.url}/models?skip=${skip}&limit=${limit}&sort=name`).pipe(map(res => res.result));
  }

  /**
   * Search templates
   */
  search(query: string): Observable<any> {
    return this.http.get<any>(`${this.url}/search/models?q=${query}`);
  }
}
